import {
  adjustmentSessionIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const partialUndoAdjustmentSession = {
  name: "partialUndoAdjustmentSession" as const,
  input: z.object({
    sessionId: adjustmentSessionIdFormat.schema,
    items: z.array(
      z.object({
        productId: productIdFormat.schema,
        quantity: z.number().int().positive(),
      }),
    ),
  }),
  output: z.object({ success: z.boolean(), pending: z.boolean().optional() }),
};
